import Type from "@/model/types/Type";

const type = {
    FULL: 1,
    ONLY_VIEW: 2,
}

const list = [
    {
        value: type.FULL,
        text: "Responsável",
    },
    {
        value: type.ONLY_VIEW,
        text: "Visualização",
    },

]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}